// extracted by mini-css-extract-plugin
export default {"resetButton":"hTiV_Ds","container":"CMiBYAg","root":"ZpRnG3m","ghost":"MWkxgCh","preloaderItem":"AKS1oKH"};